import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}; // @ts-nocheck


import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { storeArq } from 'correos-arq-utils';

var PrivateRoute = function PrivateRoute(_a) {
  var Component = _a.component,
      auth = _a.auth,
      rest = __rest(_a, ["component", "auth"]);

  try {
    storeArq.load();
    var check = true; // recoge las properties declaradas en MHorizontal.js

    var propertiesAcWeb = storeArq.data.auth.propertiesAcWeb; // Para usuarios ya autenticados || Para usuarios en login

    var acciones = _toConsumableArray(new Set(storeArq.data.auth.userInfo.accionesWeb.map(function (ac) {
      return ac.path;
    }))) || _toConsumableArray(new Set(auth.userInfo.accionesWeb.map(function (ac) {
      return ac.path;
    })));

    var buscarSubMenu = function buscarSubMenu(key) {
      var newSubMenu = []; // Para usuarios ya autenticados || Para usuarios en login

      var ac = _toConsumableArray(new Set(storeArq.data.auth.userInfo.accionesWeb.map(function (ac) {
        return ac;
      }))) || _toConsumableArray(new Set(auth.userInfo.accionesWeb.map(function (ac) {
        return ac;
      }))); //Para buscar los submenus permitidos


      newSubMenu = ac.filter(function (items) {
        return items.path === key;
      }).filter(function (items) {
        return items.sub !== null;
      }).map(function (items) {
        return items.sub;
      })[0];
      return newSubMenu;
    }; //incluir los submenus


    acciones.map(function (ac) {
      var aux = buscarSubMenu(ac);

      if (aux !== undefined) {
        return acciones.push.apply(acciones, aux.map(function (sub) {
          return sub.path;
        }));
      } else {
        return acciones;
      }
    });

    if (propertiesAcWeb.includes(rest.path)) {
      check = acciones.includes(rest.path); // esta condición (sólo aplicable si la url está en properties) comprueba que la url está en sus accionesWeb
      // true por defecto para el resto puesto que son pantallas que dependen en las anteriores de menú
    }

    return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
      render: function render(props) {
        return auth.token && check === true //comprueba que haya token + la url a la que intente acceder esté en su token (redundante)
        ?
        /*#__PURE__*/
        React.createElement(Component, props) : /*#__PURE__*/React.createElement(Redirect, {
          to: {
            pathname: '/login',
            state: {
              from: props.location
            }
          }
        });
      }
    }));
  } catch (error) {
    throw new Error("Error: ".concat(error));
  }
};

export default PrivateRoute;